export default __webpack_public_path__ + "static/media/reset-password-v2-dark.71a7ca42.svg";